import { HeroSection } from "@/components/heros/section-hero";
import { AboutTransportHomeSection } from "@/components/sections/section-about-home";
import { BannerSection } from "@/components/sections/section-banner";
import { BlogSection } from "@/components/sections/section-blog";
import { CidadesSection } from "@/components/sections/section-cities-path";
import { ColetaPersonalizadaSection } from "@/components/sections/section-coleta-personalizada";
import { FacilidadeSegurancaSection } from "@/components/sections/section-facilidade-seguranca";
import { ReembolsoIntegralSection } from "@/components/sections/section-integral-reembolso";
import { JourneySection } from "@/components/sections/section-journey";
import { ModalidadeTransporteSection } from "@/components/sections/section-modalidade-transporte";
import { PlataformaDigitalSection } from "@/components/sections/section-plataforma-digital";
import { RastreamentoTempoRealSection } from "@/components/sections/section-rastreamento-tempo-real";
import { RedeNacionalSection } from "@/components/sections/section-rede-nacional";
import { SegurosSection } from "@/components/sections/section-seguro";
import { StatsSection } from "@/components/sections/section-stats";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { TransportSection } from "@/components/sections/section-transport";
import { TransportMessageSection } from "@/components/sections/section-transport-message";
import { WhoSection } from "@/components/sections/section-who";

export default function Home() {
  return (
    <div className="min-h-screen bg-n-bg-1">
      <HeroSection />

      <AboutTransportHomeSection />

      <TransportSection />

      <StatsSection />

      <JourneySection />

      <WhoSection />

      <TransportMessageSection />

      <RedeNacionalSection />

      <ColetaPersonalizadaSection />

      <RastreamentoTempoRealSection />

      <SegurosSection />

      <ModalidadeTransporteSection />

      <ReembolsoIntegralSection />

      <FacilidadeSegurancaSection />

      <PlataformaDigitalSection />

      <TestimonialSection />

      <CidadesSection />

      <BlogSection />

      <BannerSection title="Faça agora uma cotação e agende o transporte do seu veículo !" />
    </div>
  );
}
